<template>
  <div class="power">
    <div v-html="detailObj.description"></div>
  </div>
</template>

<script>

export default {
  props: {
    detailObj: Object,
  },
  data() {
    return {
    }
  },
  components: {
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

</style>
